import { usePermissions } from 'hooks/usePermissions';
import { Permission } from 'types/embedded/permission';

import { TableFileViewerList } from './components/TableFileViewerList/TableFileViewerList';
import { TableFileViewerUploader } from './components/TableFileViewerUploader/TableFileViewerUploader';
import { ContainerStyled } from './TableFileViewer.styled';

type TableFileViewerProps = {
  entityId: number;
  entityName: string;
  allowUpdate?: boolean;
  allowShow?: boolean;
};

export const TableFileViewer: React.FC<TableFileViewerProps> = ({
  entityName,
  entityId,
  allowUpdate = false,
  allowShow = true,
}) => {
  const { hasResourcePermissions } = usePermissions();
  return (
    <ContainerStyled>
      {hasResourcePermissions('upload_files', [Permission.Full, Permission.Update]) &&
        allowUpdate && <TableFileViewerUploader entityId={entityId} entityName={entityName} />}
      {allowShow && (
        <TableFileViewerList
          allowUpdate={allowUpdate}
          entityId={entityId}
          entityName={entityName}
        />
      )}
    </ContainerStyled>
  );
};
